<template>
<div class="chapter">
<div class="inner_page">
<a id="p2"></a>
<p class="sink"> </p>
<p class="center ">
<em>For Ann, Amelia, and Claire</em>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?5eb6f83e